module.exports = __webpack_public_path__ + "img/2014-Loyalty-Awardee_18.7b2b0f3a.jpg";